/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Topbar/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import React from 'react'
import Title from 'DesignSystem/Title/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Topbar({
  children,
  viewPath = "/App/Account/Content/Profile/Topbar"
  
}) {
  let flow = fromFlow.useFlow()
  return (<React.Fragment
>
<div
  data-testid="Topbar.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<Title
  viewPath={`${viewPath}/Title`}
 text="Profile"
/>
<Title
  viewPath={`${viewPath}/Title`}
 marginLeft={4}
 text={flow.has(fromFlow.normalizePath(viewPath, '../Content/TwoFactorAuth')) ? "• Two Factor Authentication" : ""}
/>
</div>
{children}
</React.Fragment>)
}